import React from 'react'

const LoaderBootStrap = () => {
    return (
        <div>
            <div className="translatable spinner-grow text-muted"></div>
            <div className="translatable spinner-grow text-primary"></div>
            <div className="translatable spinner-grow text-success"></div>
            <div className="translatable spinner-grow text-info"></div>
            <div className="translatable spinner-grow text-warning"></div>
            <div className="translatable spinner-grow text-danger"></div>
            <div className="translatable spinner-grow text-secondary"></div>
            <div className="translatable spinner-grow text-dark"></div>
            <div className="translatable spinner-grow text-light"></div>
        </div>
    )
}

export default LoaderBootStrap;